import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260326_rename_by_tag_to_by_label",
  description: "Rename BY_TAG selection method to BY_LABEL in view template overrides",
  apply(json: any) {
    for (const vtoId in json.viewTemplateOverrides) {
      const vto = json.viewTemplateOverrides[vtoId];

      if (vto.selectionMethod === "BY_TAG") {
        vto.selectionMethod = "BY_LABEL";
      }
    }

    return json;
  },
};

export default migration;
